import React from "react";
import {
  Car,
  BriefcaseMedical,
  HeartPulse,
  ShieldCheck,
  PiggyBank,
  Scale,
  TrendingUp,
  Compass,
  FileSearch,
  ArrowUpRight,
} from "lucide-react";
import { SERVICE_GROUPS } from "@/lib/site";

const iconMap = {
  Car,
  BriefcaseMedical,
  HeartPulse,
  ShieldCheck,
  PiggyBank,
  Scale,
  TrendingUp,
  Compass,
  FileSearch,
};

export default function Services() {
  return (
    <section
      id="storitve"
      data-testid="services-section"
      className="py-24 md:py-32"
      style={{ background: "var(--vp-surface)" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-16">
          <div className="text-sm font-semibold tracking-widest uppercase text-[var(--vp-primary)] mb-3">
            Storitve
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight">
            Celovita zavarovalna oskrba —
            <br /> na enem mestu.
          </h2>
          <p className="mt-5 text-[var(--vp-muted)] text-base leading-relaxed">
            Tri področja, en partner. Od reševanja izzivov, do zaščite vsakdana in
            dolgoročnega plemenitenja premoženja.
          </p>
        </div>

        <div className="space-y-20">
          {SERVICE_GROUPS.map((group) => (
            <div key={group.key} data-testid={`service-group-${group.key}`}>
              <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
                <div>
                  <div className="inline-flex items-center gap-2 mb-2">
                    <span
                      className="h-1.5 w-8 rounded-full"
                      style={{ background: "var(--vp-accent)" }}
                    />
                    <span className="text-xs font-semibold tracking-widest uppercase text-[var(--vp-muted)]">
                      {group.title}
                    </span>
                  </div>
                  <h3 className="font-display text-2xl sm:text-3xl font-bold tracking-tight max-w-xl">
                    {group.subtitle}
                  </h3>
                </div>
              </div>

              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {group.services.map((s) => {
                  const Icon = iconMap[s.icon];
                  return (
                    <a
                      key={s.key}
                      href="#kontakt"
                      data-testid={`service-card-${s.key}`}
                      className="group relative rounded-2xl border border-[var(--vp-border)] bg-white p-8 hover:border-[var(--vp-primary)]/40 hover:shadow-[0_12px_40px_rgba(45,106,79,0.08)] transition-all duration-300"
                    >
                      <div
                        className="inline-flex h-12 w-12 items-center justify-center rounded-xl mb-6 transition-transform group-hover:scale-105"
                        style={{
                          background: "var(--vp-sand)",
                          color: "var(--vp-primary)",
                        }}
                      >
                        {Icon ? <Icon size={22} /> : null}
                      </div>
                      <h4 className="font-display text-xl font-bold tracking-tight mb-2">
                        {s.title}
                      </h4>
                      <p className="text-sm text-[var(--vp-muted)] leading-relaxed">
                        {s.desc}
                      </p>
                      <div className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-[var(--vp-primary)] opacity-0 group-hover:opacity-100 transition-opacity">
                        Več informacij <ArrowUpRight size={14} />
                      </div>
                    </a>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
